import {IWarehouse} from "../Warehouses/IWarehouse";

export interface IStockConvertRule {
    contains: number // 10
    operator: string // "<=>"
    count: number // 0
}

export enum StockConvertRuleType {
    Percentage = 'pr',
    Distribute = 'ds',
    Rules = 'rs',
}

export interface IStocksExportRuleForWarehouse {
    isEnableAutoExport: boolean
    isDistribute: boolean
    stockConvertRuleType: StockConvertRuleType
    stockConvertRules: IStockConvertRule[]
    warehouseID: string
    warehouse: IWarehouse
    sourceWhID: string
    isTakeAllWhsAsSource: boolean
    sourceWhIDs: string[]
    percentageOfTotal: number
    filterID: number|null
}